module.exports = __webpack_public_path__ + "img/icon_confirm.e65058f5.png";